import React, { useContext } from 'react';
import '../../ui-styles/bottomSlider/BottomDeleteSlide.css';
import { LangCtx } from "../context";

const ExceededCancellation = (props) => {
    const { l } = useContext(LangCtx);

    return <div className={props.slideC ? "btmEDSlider slideUp" : "btmEDSlider"}>
        <div className="btmEDCntnr">
            <div className="btmSliderGroup">
                <div className="ConfirmationTxt ">
                    <span className="alertTxt">{props?.paymentMode !== "free" ? l.cancel_limit_txt : l.cancel_appointment }</span>
                </div>
                <div className="txtCenter pdngMD">
                    <span className="redTxt">{props?.paymentMode !== "free" ? l.cancel_note_txt : ""}</span>
                </div>
                <div className="btnSlideItem" onClick={props.handleCanConfirm}>
                    <span className="btmTxtDft">{l.yes_cancel_btn}</span>
                </div>
            </div>
            <div className="btmSliderClose" onClick={props.handleCancel}>
                <span className="btmTxtDanger">{l.no_btn}</span>
            </div>
        </div>
    </div>

}

export default ExceededCancellation;
